module.exports = __webpack_public_path__ + "8d415aea24833e58ad749b8382ea5cfb.png";